
<div class="country-information">
    <div class="navbar navbar-fixed navbar-toggleable-sm navbar-deloitte-light sticky">
        <div class="container justify-content-between pl-0 pl-lg-3 pr-0 pr-lg-3">
            <div class="navbar-brand hidden-sm-down" href="#">
                <span class="navbar-mobile-title">
                    {{showHistory ? "Publication history" : "Location information "}}
                </span>
            </div>

            <div class="hidden-sm-down col-7 text-right">
                <div class="d-flex align-items-center justify-content-end">
                    <span class="mr-2 text-muted">Change location</span>
                    <div class="flex-shrink-0" style="width: 280px;">
                        <ng-select id="ddlcountryselection"
                                   [items]="countryDropdownItems"
                                   [ngModel]="selectedCountry"
                                   (ngModelChange)="onCountrySelected($event)"
                                   bindLabel="text"
                                   bindValue="id"
                                   [clearable]="true"
                                   [searchable]="true"
                                   [placeholder]="'Select a location'">
                            <ng-template ng-option-tmp let-item="item" let-index="index">
                                <span class="d-flex align-items-center">
                                    <i class="{{item.flagClass}} mr-2"></i>
                                    <span>{{item.text}}</span>
                                </span>
                            </ng-template>
                            <ng-template ng-label-tmp let-item="item">
                                <span class="d-flex align-items-center">
                                    <i class="{{item.flagClass}} mr-2"></i>
                                    <span>{{item.text}}</span>
                                </span>
                            </ng-template>
                        </ng-select>
                    </div>
                </div>
            </div>
        </div>
        <div class="hidden-md-up">
            <span class="d-block">
                <ng-select id="ddlcountryselection-mobile"
                           [items]="countryDropdownItems"
                           [ngModel]="selectedCountry"
                           (ngModelChange)="onCountrySelected($event)"
                           bindLabel="text"
                           bindValue="id"
                           [clearable]="true">
                    <ng-template ng-option-tmp let-item="item" let-index="index">
                        <span class="d-flex align-items-center">
                            <i class="{{item.flagClass}} mr-2"></i>
                            <span>{{item.text}}</span>
                        </span>
                    </ng-template>
                    <ng-template ng-label-tmp let-item="item">
                        <span class="d-flex align-items-center">
                            <i class="{{item.flagClass}} mr-2"></i>
                            <span>{{item.text}}</span>
                        </span>
                    </ng-template>
                </ng-select>
            </span>
        </div>
    </div>

    <div class="band pb-5 mt-3 mt-lg-5">

        <div class="container">
            @if (isLoading) {
            <div class="loading-spinner-container">
                <div class="loading-spinner">
                </div>
            </div>
            }
            @if (countryInformation && countryInformation.itemConfigs && countryInformation.itemConfigs.length > 0) {
            <div class="row">
                <div class="col">
                    <div class="pt-lg-5 text-md-right">
                        <button *featureToggle="features.AuditHistory" class="btn btn-info mr-1" (click)="toggleHistoryInformation()">{{showHistory ? "View Information" : "View History"}}</button>
                        <downloadfile #download></downloadfile>
                        <button class="btn btn-info" [ngClass]="{'btn-loading': downloadingContent}" [disabled]="downloadingContent" (click)="downloadFile()" *featureToggle="features.PdfDownload">Download information <i class="fa fa-download ml-2"></i></button>
                        <downloadfile #download></downloadfile>
                        <hr>
                        <small *featureToggle="features.PublishedDate"> <strong>Last modified:</strong> {{countryInformation.lastUpdated}}</small>
                    </div>
                </div>
            </div>
            }

            <div class="row">
                @if (!showHistory ) {
                <div class="col-xs-12 col-md-3 pl-0">
                    @if (countryInformation && countryInformation.itemConfigs && countryInformation.itemConfigs.length > 0) {
                    <div class="pt-4">
                        <p class="h4 pl-3 pb-4">Sections</p>
                        <ul class="categories nav flex-column mt-3 ml-3">
                            @for (category of countryInformation.itemConfigs; track category) {
                            <li class="nav-item d-block mb-3" role="button"
                                (click)="onCategoryClick(category)"
                                [ngClass]="{'active': selectedCategory?.id === category.id}">
                                {{category.name}}
                            </li>
                            }
                        </ul>
                    </div>
                    }
                </div>
                <div class="col-xs-12 col-md-9 pl-md-5 content-area pt-3">
                    @if (selectedCategory) {
                    <country-content [item]="selectedCategory" [depth]="1" [countryCode]="countryCode"></country-content>
                    }
                    <no-content-message message="No content for {{country?.shortName}}" [visible]="!selectedCategory"></no-content-message>
                </div>
                }

                @if (showHistory) {
                <div class="center col-10 offset-1 pt-5">
                    <div class="text-justify">
                        <p class="text-muted ml-2">A historical summary of changes made to the content for {{country?.shortName}} (most recent live publication first) </p>
                    </div>
                    <div class="card">
                        <div class="card-body p-0">
                            <ul class="p-0 mb-0">
                                @for (publication of countryHistoryList; track publication) {
                                <li class="list-group-item list-group-item-action">
                                    <div class="col-12" (click)="onPublicationClick(publication)">
                                        <div class="row">
                                            <div class="col-11">
                                                <p class="mb-0">
                                                    <strong>Content published on {{publication.updatedDate | date:'d MMMM y HH:mm'}}</strong>
                                                </p>
                                            </div>
                                            <div class="col-1">
                                                <i [ngClass]="(!publication.expanded)? 'fa fa-caret-down mr-2 text-success':'fa fa-caret-up text-success mr-1'"></i>
                                            </div>
                                        </div>
                                    </div>
                                    @if (publication.expanded) {
                                    <div class="col-12 mt-2 p-0">
                                        <country-publicationhistory [content]="publication" [countryCode]="countryCode"></country-publicationhistory>
                                    </div>
                                    }
                                </li>
                                }
                            </ul>
                        </div>
                    </div>
                </div>
                }
            </div>
        </div>
    </div>
</div>

